import Marquee from "react-fast-marquee";

const brandLogos = [
  { name: "Google", url: "https://cdn.simpleicons.org/google/9ca3af" },
  { name: "Microsoft", url: "https://cdn.simpleicons.org/microsoft/9ca3af" },
  { name: "Amazon", url: "https://cdn.simpleicons.org/amazon/9ca3af" },
  { name: "Shopify", url: "https://cdn.simpleicons.org/shopify/9ca3af" },
  { name: "Adobe", url: "https://cdn.simpleicons.org/adobe/9ca3af" },
  { name: "Slack", url: "https://cdn.simpleicons.org/slack/9ca3af" },
  { name: "Netflix", url: "https://cdn.simpleicons.org/netflix/9ca3af" },
  { name: "Spotify", url: "https://cdn.simpleicons.org/spotify/9ca3af" },
  { name: "Airbnb", url: "https://cdn.simpleicons.org/airbnb/9ca3af" },
  { name: "Uber", url: "https://cdn.simpleicons.org/uber/9ca3af" },
  { name: "PayPal", url: "https://cdn.simpleicons.org/paypal/9ca3af" },
  { name: "Meta", url: "https://cdn.simpleicons.org/meta/9ca3af" },
];

const BrandSection: React.FC = () => {
  return (
    <section className="brand pt-170 pb-150">
      <div className="container">
        <div className="xb-brand-wrap xb-border">
          <div className="brand-sub-title xb-border">
            <p>
              Trusted by <span>5,000+ resellers</span> worldwide
            </p>
          </div>

          <Marquee speed={40} gradient={false} pauseOnHover={false}>
            <div className="brand-marquee marquee-left">
              <div className="xb-brand-inner ul_li_between">
                {brandLogos.map((brand, index) => (
                  <div className="xb-brand-item" key={index} style={{ padding: "0 40px" }}>
                    <img
                      src={brand.url}
                      alt={brand.name}
                      style={{ height: 40, width: "auto", objectFit: "contain" }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </Marquee>
        </div>
      </div>
    </section>
  );
};

export default BrandSection;
